module.exports = "/lucky-balls/img/regular_game/ball_holder.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/ball_holder.png
// module id = 1123
// module chunks = 0